import React, { useState } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import classnames from 'classnames'
import FormInput from './FormInput'
import Button from './Button'
import Spinner from './Spinner'
import { patchEmailIdentitiesPassword, getAccount } from '../actions/api'
import { profileSelector } from '../reducers/profile'
import find from 'lodash/find'
import get from 'lodash/get'
import reject from 'lodash/reject'

function PasswordForm({ profile, patchEmailIdentitiesPassword, getAccount }) {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [errors, setErrors] = useState([])
  const [error, setError] = useState(null)

  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('')

  const handlePasswordChange = event => {
    setPassword(event.target.value)
    setErrors(reject(errors, { type: 'password' }))
  }
  const handleNewPasswordChange = event => {
    setNewPassword(event.target.value)
    setErrors(reject(errors, { type: 'new_password' }))
  }
  const handleNewPasswordConfirmationChange = event => {
    setNewPasswordConfirmation(event.target.value)
    setErrors(reject(errors, { type: 'new_password_confirmation' }))
  }

  const handleSaveClick = async () => {
    setError(null)
    setErrors([])
    try {
      setLoading(true)
      let attributes = {
        email: get(profile, 'email'),
        password,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation
      }
      if (profile.passwordPresent) {
        attributes.password = password
      }
      const response = await patchEmailIdentitiesPassword(attributes)
      await getAccount()
      setLoading(false)
      if (response.payload.errors && response.payload.errors.length > 0) {
        setErrors(response.payload.errors)
      } else if (response.payload.error || response.error) {
        setError(String(response.payload.error || response.payload.message || response.error))
      } else if (response.payload.status === 'success') {
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 3000)
        setPassword('')
        setNewPassword('')
        setNewPasswordConfirmation('')
      }
    } catch (error) {
      setLoading(false)
      setError(String(error))
    }
  }

  if (!get(profile, 'email')) {
    return null
  }

  return (
    <div className="account-block account-block--separated account-block--padding-small">
      <div className="account-block__title">Пароль</div>
      {profile.passwordPresent && (
        <FormInput
          label="Текущий пароль"
          defaultType="password"
          value={password}
          onChange={handlePasswordChange}
          error={find(errors, { type: 'password' })}
          disabled={loading}
          isSettings
        />
      )}
      <FormInput
        label="Новый пароль"
        defaultType="password"
        value={newPassword}
        onChange={handleNewPasswordChange}
        error={find(errors, { type: 'new_password' })}
        disabled={loading}
        isSettings
      />
      <FormInput
        label="Подтвердите новый пароль"
        defaultType="password"
        value={newPasswordConfirmation}
        onChange={handleNewPasswordConfirmationChange}
        error={find(errors, { type: 'new_password_confirmation' })}
        disabled={loading}
        isSettings
      />
      {error && <div className="account-form__error account-form__error--settings">{error}</div>}
      <div className="account-form__bottom">
        <Button onClick={handleSaveClick} disabled={loading} isSettings>
          {loading ? <Spinner /> : 'Изменить пароль'}
        </Button>
        <div
          className={classnames('account-form__code-icon', {
            'account-form__code-icon--success': success
          })}
        />
      </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector
})

export default connect(mapStateToProps, { patchEmailIdentitiesPassword, getAccount })(PasswordForm)
